import { RootState } from "common/reducers";
import { Nullable } from "common/types";

export const authenticated = (state: RootState) => state.getIn(["auth", "authenticated"]);
export const authenticating = (state: RootState) => state.getIn(["auth", "authenticating"]);
export const token = (state: RootState) => state.getIn(["auth", "token"]);
export const accessUid = (state: RootState): Nullable<string> => state.getIn(["auth", "accessUid"]);
